import { NgModule } from '@angular/core';
import { UIElementModule } from 'src/app/core';
import { TrainingList, TrainingListItem } from './training-list/training-list';
import { TrainingFormDialog } from './dialog/training-form/training-form';
import { TrainingService } from './training.service';

const declareAndExport = [
	TrainingList,
	TrainingListItem
]
const declareAndEntryComponent = [
	TrainingFormDialog,
]

@NgModule({
	imports: [UIElementModule],
	declarations: [declareAndExport, declareAndEntryComponent],
	exports: [declareAndExport],
	entryComponents: [declareAndEntryComponent],
	providers: [TrainingService]
})
export class TrainingModule { }
